import React from 'react';
import { useShowContextRequired, Text } from 'ui-builder';
import { MarketRequest } from 'nekst-api';

export default function UserField() {
  const { data } = useShowContextRequired<MarketRequest>();

  const user = data._createdBy;

  return (
    <Text>
      {user.name.fullName} ({user.primaryEmail})
    </Text>
  )
}
